import  {useState} from "react";
import { Input, NavItem } from 'reactstrap';

function CustomCheckBox(props) {

    let [checked,updateChecked] = useState(props.checked);
    let className = '';

    const handleChange = element => {
        updateChecked(element.target.checked);
        props.onChange(element);
    };

    if(props.error){
        className="is-invalid";
    }
    return (
        <div>
            <Input
                id={'id_'+props.name} 
                onChange={handleChange}
                className={className}
                type="checkbox"
                name={props.name}
                checked={checked}
                disabled = {props.readOnly}
                autoFocus={props.autoFocus?true:false}
            />
            {props.label}
            {props.required && (
                <span className="required"> *</span>
            )}
            {props.error && (
                <span 
                    class="error invalid-feedback" 
                    style={{display:'inline',marginLeft:'10px'}}>
                        {props.error}
                </span>
            )}
        </div>
    );
}
export default CustomCheckBox;
